"use strict";

import { onReady } from '../core/ready.js';

function initHeroCarouselBlock() {
    const carouselHeroBlocks = document.querySelectorAll('.carousel');
    if (!carouselHeroBlocks.length) return;

    carouselHeroBlocks.forEach((carouselBlock) => {
        const items = () => Array.from(carouselBlock.querySelectorAll('.carousel-item'));
        const activeIndex = () => items().findIndex((el) => el.classList.contains('active'));

        const preloadAdjacentVideos = () => {
            const slides = items();
            const n = slides.length;
            if (n === 0) return;
            const idx = activeIndex();
            if (idx === -1) return;
            const nextSlide = slides[(idx + 1) % n];
            const prevSlide = slides[(idx - 1 + n) % n];
            [nextSlide, prevSlide].forEach((slide) => {
                const video = slide?.querySelector('.slide-video');
                if (video && video.readyState < 2) {
                    video.muted = true;
                    video.loop = true;
                    video.load();
                }
            });
        };

        // Aggiungo una classe a carousel-control-prev e carousel-control-next
        // (frecce + contatore) in base al colore del testo della slide
        const updateControlColors = (slide = null) => {
            const targetSlide = slide || carouselBlock.querySelector('.carousel-item.active');
            if (!targetSlide) return;

            const controlColor = targetSlide.getAttribute('data-control-color');
            const prevControl = carouselBlock.querySelector('.carousel-control-prev');
            const nextControl = carouselBlock.querySelector('.carousel-control-next');
            const isDark = controlColor === 'default';

            [prevControl, nextControl].forEach((control) => {
                if (!control) return;
                control.classList.toggle('carousel-control-dark', isDark);
            });
        };

        const counterCurrent = carouselBlock.querySelector('.carousel-counter-current');
        const counterTotal = carouselBlock.querySelector('.carousel-counter-total');

        const updateCounter = () => {
            if (!counterCurrent || !counterTotal) return;
            const slides = items();
            const idx = activeIndex();
            if (idx === -1) return;
            counterCurrent.textContent = idx + 1;
            counterTotal.textContent = slides.length;
        };

        // All'inizio della transizione: colori controlli + preload video in arrivo
        carouselBlock.addEventListener('slide.bs.carousel', function (event) {
            const incomingSlide = event.relatedTarget;
            updateControlColors(incomingSlide);

            const incomingVideo = incomingSlide?.querySelector('.slide-video');
            if (incomingVideo) {
                incomingVideo.muted = true;
                incomingVideo.loop = true;
                incomingVideo.load();
            }
        });

        // Inizializzo i colori dei controlli e il contatore
        updateControlColors();
        updateCounter();

        carouselBlock.addEventListener('slid.bs.carousel', () => {
            preloadAdjacentVideos();
            updateControlColors();
            updateCounter();
        });

        preloadAdjacentVideos();
    });
    
}

onReady(initHeroCarouselBlock);
